import typeMap from '../../Data/typeMap'
let beta = ''
const makeRequest = async function (token, req, method) {
  // console.log('makeRequest with request', req)
  if (req.file) {
    if (typeof req.file.serialize === 'function') {
      req.file = req.file.serialize()
    }
  }
  // req.userToken = token
  // if(req.user&&!req.user.token) req.user.token = token
  // console.log('after parsing request', req)
  if (!req.file) delete req.file
  // console.log('run request with token', token)
  // console.log(req)
  let json = null
  try {
    // console.log('trying', `https:${global.process.env.APP_URL}${beta}/files/${method}`)
    const res = await fetch(`${process.env.REACT_APP_PROTOCOL}:${process.env.REACT_APP_APP_URL}${beta}/files/${method}`, {
      method: 'POST',
      credentials:'include',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(req)
    })
    // console.log('got this', res.body)
    json = res.json()
  } catch (e) {
    throw new Error(e.message)
  }

  return json

}

let token = ''

export const remDbInit = function (user, b) {
  token = user && user.token
  if (b) beta = '/beta'
  // console.log('remdb init with', b, user, process)
}



const remDbGet = async function (type, file) {
  const res = await makeRequest(token, { type, file }, 'get')
  return res.length === 1 ? res[0] : res
}

const remDbGetTyped = async function (type, file) {
  // console.log('get tyoed remote', type, file)
  const res = await makeRequest(token, { type, file }, 'get')
  return res.length === 1 ? res[0] : new typeMap[type](res)
}

const copyToOppositeRem = async function (type, file) {
  return makeRequest(token, { type, file }, 'copyToOppositeRem')
}


const remDbPut = async function (type, file) {
  return makeRequest(token, { type, file }, 'put')
}

const remDbBulkInsert = async function (type, file) {
  return makeRequest(token, { type, file }, 'bulkInsert')
}

const remDbKill = async function (type, file, obliterate) {
  return makeRequest(token, { type, file, obliterate }, 'kill')
}

// const remDbArchive = async function(type, file){
//   return makeRequest(token, {type, file}, 'archive')
// }

const remDbToArray = async function (type, archFlag) {
  return makeRequest(token, { type, archFlag }, 'toArray')
}

const remDbToFlatArray = async function (type, archFlag) {
  return makeRequest(token, { type, archFlag }, 'toFlatArray')
}

const getAllFlatArrays = async function () {
  const arrays = await makeRequest(token, { type: '' }, 'getAllFlatArrays')
  // console.log('got arrays', arrays)
  return arrays
}

const initChain = async function () {
  const arrays = await makeRequest(token, { type: '' }, 'initChain')
  // console.log('got arrays', arrays)
  return arrays
}

const getDiff = async function (type, _id) {
  const diffs = await makeRequest(token, { type: '', file: _id }, 'getDiff')
  console.log('got diffs', diffs)
  return diffs
}

const bulkGet = async function (type, _ids) {
  const files = await makeRequest(token, { type, file: _ids }, 'bulkGet')
  console.log('got files', files)
  return files
}

const getMarkersByInspFin = async function (type, file) {
  const res = await makeRequest(token, { file }, 'getMarkersByInspFin')
  return res
}
const getInspFinByInsp = async function (type, file) {
  const res = await makeRequest(token, { file }, 'getInspFinByInsp')
  return res
}

const getRepMarksByRep = async function (type, file) {
  // console.log('file in repmarksbyrep', file)
  const res = await makeRequest(token, { file }, 'getRepMarksByRep')
  return res
}

const getMarkersByInsp = async function (type, file) {
  const res = await makeRequest(token, { file }, 'getMarkersByInsp')
  return res
}

const lock = async function (type, file) {
  const res = await makeRequest(token, { type, file }, 'lock')
  return res
}

const unlock = async function (type, file) {
  const res = await makeRequest(token, { type, file }, 'unlock')
  return res
}

const checkLock = async function (type, file) {
  const res = await makeRequest(token, { type, file }, 'checkLock')
  return res
}

const findImagesByInspClient = async function (type, client) {
  console.log('attempting findImagesByInspClient', token, { type, file: client })
  const res = await makeRequest(token, { type, file: client }, 'findImagesByInspClient')
  return res
}

const markAsUpdated = async function (type, file) {
  const res = await makeRequest(token, { type, file }, 'markAsUpdated')
  return res
}

const getMarkerCountByParent = async function (type, file) {
  const res = await makeRequest(token, { type, file }, 'getMarkerCountByParent')
  return res
}

const getMiscImgsByType = async function (type, file) {
  const res = await makeRequest(token, { type, file }, 'getMiscImgsByType')
  return res
}

const getReportByDirName = async function (type, file) {
  const res = await makeRequest(token, { type, file }, 'getReportByDirName')
  return res
}

const archive = async function (type, file) {
  const res = await makeRequest(token, { type, file }, 'archive')
  return res
}

const unarchive = async function (type, file) {
  const res = await makeRequest(token, { type, file }, 'unarchive')
  return res
}

const getReportLockStatus = async function (type, file) {
  return makeRequest(token, { type, file }, 'getReportLockStatus')
}

const lockReportBlock = async function (type, file) {
  return makeRequest(token, { type, file }, 'lockReportBlock')
}

const unlockReportBlock = async function (type, file) {
  return makeRequest(token, { type, file }, 'unlockReportBlock')
}

const duplicate = async function (type, file){
  return makeRequest(token, {type, file}, 'duplicate')
}
export const remDbProps = {
  get: remDbGet,
  put: remDbPut,
  kill: remDbKill,
  toFlatArray: remDbToFlatArray,
  toArray: remDbToArray,
  // archive: remDbArchive,
  bulkInsert: remDbBulkInsert,
  getTyped: remDbGetTyped,
  lock,
  unlock,
  checkLock,
  getAllFlatArrays,
  initChain,
  getMarkersByInspFin,
  getMarkersByInsp,
  getInspFinByInsp,
  getRepMarksByRep,
  copyToOppositeRem,
  getDiff,
  bulkGet,
  findImagesByInspClient,
  markAsUpdated,
  getMarkerCountByParent,
  getMiscImgsByType,
  getReportByDirName,
  archive,
  unarchive,
  getReportLockStatus,
  lockReportBlock,
  unlockReportBlock,
  duplicate
}



// export remDbInit
